module.exports = "/images/icon-user.svg?36b18463db531a7d5b83d03b200ee242";